<template>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.75"
      y="0.75"
      width="11.5"
      height="11.5"
      rx="1.75"
      :fill="colorHexCode"
      :stroke="colorHexCode"
      stroke-width="0.5"
    />
    <rect x="3.5" y="3.5" width="6" height="1.5" fill="#fff" />
    <rect x="3.5" y="6" width="6" height="1.5" fill="#fff" />
    <rect x="3.5" y="8.5" width="6" height="1.5" fill="#fff" />
  </svg>
</template>

<script>
export default {
  name: 'ProjectIcon',
  props: {
    color: {
      default: '606060'
    }
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    colorHexCode() {
      return `#${this.color}`
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
